/* KUTEE' quick add — card-level "Add to bag" / "Buy now" without opening
   the PDP. Buttons carry data-ku-add or data-ku-buy + data-variant-id.
   Add: adds 1 unit, re-renders Dawn's cart drawer and opens it.
   Buy: adds 1 unit, then sends the buyer to checkout. */
(() => {
  // Guard against double-init: several sections load this file, and a product
  // page renders both ku-product and the "In another mood" featured collection,
  // which would otherwise attach the delegated listener twice (double-add).
  if (window.__kuQuickAddInit) return;
  window.__kuQuickAddInit = true;

  const addVariant = async (variantId) => {
    const drawer = document.querySelector('cart-drawer');
    const body = { items: [{ id: variantId, quantity: 1 }] };

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.description || data.message || 'Could not add to bag');
    }
    return { data, drawer };
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ku-add], [data-ku-buy]');
    if (!button || button.hasAttribute('disabled')) return;
    event.preventDefault();

    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    const isBuyNow = button.hasAttribute('data-ku-buy');
    button.setAttribute('disabled', '');
    button.classList.add('loading');

    try {
      const { data, drawer } = await addVariant(variantId);

      if (isBuyNow) {
        window.location.href = '/checkout';
        return;
      }

      if (drawer && data.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      } else {
        window.location.href = window.routes.cart_url;
      }
    } catch (error) {
      button.classList.add('ku-quick-add--error');
      button.setAttribute('title', error.message);
      setTimeout(() => button.classList.remove('ku-quick-add--error'), 2000);
    } finally {
      button.removeAttribute('disabled');
      button.classList.remove('loading');
    }
  });
})();
